import React from 'react'
import { Button } from 'antd'

const FooterActions = ({
  t,
  onClickCancel,
  onClickTitle,
  title,
  loading,
  isDisabled,
  hideTitleButton = false
}) => {
  return [
    <Button
      key="cancel"
      type="default"
      shape="round"
      size="default"
      disabled={loading}
      onClick={onClickCancel}
      className="ant-btn rounded"
    >
      {t('buttons:cancel')}
    </Button>,
    !hideTitleButton && (
      <Button
        key="title"
        type="primary"
        shape="round"
        size="default"
        loading={loading}
        disabled={isDisabled}
        onClick={onClickTitle}
        className="ant-btn rounded ant-btn-primary"
      >
        {title}
      </Button>
    )
  ].filter(Boolean)
}

export default FooterActions
